import { Alert, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { GrPowerCycle } from "react-icons/gr";
import { BsCloudDownload } from "react-icons/bs";
import { RiFileEditFill } from "react-icons/ri";
import { useSelector } from 'react-redux';
import { PaymentAPI } from "../../api/PaymentAPI";
import { AuthContext } from '../auth/AuthContext';
import emtyBox from '../../assets/images/bill.png'  
import invoiceImg from '../../assets/images/invoice.png'


const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
};
const Billing = ({invoices }) => {
 
    return (
        <div className='billing_container'>
            <TableContainer sx={{
                width: '100%',
                '@media (max-width:1000px)': {
                    width: '100%',
                },
                '@media (max-width:400px)': {
                    width: '100%',
                    boxShadow: 5
                },
                borderRadius: 3
            }} component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Invoice number</TableCell>
                            <TableCell align="left">Amount</TableCell>
                            <TableCell align="left">Status</TableCell>
                            <TableCell align="left">Frequency</TableCell>
                            <TableCell align="left">Created</TableCell>
                            <TableCell align="left">Due</TableCell>
                            <TableCell align="left">PDF</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {invoices.map((invoice) => (
                            <TableRow
                                key={invoice.invoiceNumber}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell sx={{ whiteSpace: 'nowrap' }} align="left">
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {invoice.invoiceNumber !== null && <img className='pdf_icon' src={invoiceImg} alt="pdf" />}{invoice.invoiceNumber}
                                    </div>
                                </TableCell>
                                <TableCell align="left">${(invoice.amount / 100).toFixed(2)}</TableCell>
                                <TableCell align="left">

                                    {invoice.status === 'paid' &&
                                        <Alert sx={{ width: 'max-content', textTransform: 'capitalize', color: 'green', fontWeight: 600 }} severity="success">{invoice.status}
                                        </Alert>}

                                    {invoice.status === 'draft' &&
                                        <Alert sx={{ width: 'max-content', textTransform: 'capitalize', color: 'rgb(207, 104, 6)', fontWeight: 600 }} severity="warning">{invoice.status}
                                        </Alert>}

                                </TableCell>
                                <TableCell sx={{ textTransform: 'capitalize', whiteSpace: 'nowrap' }} align="left">
                                    {invoice.frequency && <GrPowerCycle className='frequency_icon' />}
                                    {invoice.frequency ? invoice.frequency + 'ly' : invoice.frequency}
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }} align="left">{new Date(invoice.created * 1000).toLocaleString('en-US', options)}</TableCell>
                                <TableCell align="left">${(invoice.due / 100).toFixed(2)}</TableCell>
                                <TableCell align="left">
                                    <Link className='pdf_dowload_btn' to={invoice.pdfLink}>
                                        <BsCloudDownload className='pdf_dowload_icon' />Download
                                    </Link>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                {invoices.length == 0 &&
                    <div className="empty_invoice_table">
                        <img src={emtyBox} alt="exmpty" />
                        <p>No Invoice Found</p>
                    </div>}
            </TableContainer>
            
        </div>
    )
}

export default Billing